/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from '../team/defs.defs'

const $nsid = 'tools.ozone.queue.defs'

type $nsid = typeof $nsid

export { $nsid }

type QueueView = {
  $type?: 'tools.ozone.queue.defs#queueView'

  /**
   * Queue ID
   */
  id: number

  /**
   * Display name of the queue
   */
  name: string

  /**
   * Statistics about this queue
   */
  stats: QueueStats

  /**
   * Whether this queue is currently active
   */
  enabled: boolean
  createdAt: l.DatetimeString

  /**
   * DID of moderator who created this queue
   */
  createdBy: l.DidString

  /**
   * When the queue was deleted, if applicable
   */
  deletedAt?: l.DatetimeString
  updatedAt: l.DatetimeString

  /**
   * Collection name for record subjects (e.g., 'app.bsky.feed.post')
   */
  collection?: l.NsidString

  /**
   * Optional description of the queue
   */
  description?: string

  /**
   * Report reason types this queue accepts (fully qualified NSIDs)
   */
  reportTypes?: string[]

  /**
   * Subject types this queue accepts.
   */
  subjectTypes?: (
    'account' | 'record' | 'message' | 'conversation' | l.UnknownString
  )[]

  /**
   * Labels recommended for this queue and used as a fallback when routing label appeals
   */
  recommendedLabels?: string[]

  /**
   * Policy keys recommended when actioning reports in this queue
   */
  recommendedPolicies?: string[]
}

export type { QueueView }

const queueView = /*#__PURE__*/ l.typedObject<QueueView>(
  $nsid,
  'queueView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    name: /*#__PURE__*/ l.string(),
    stats: /*#__PURE__*/ l.ref<QueueStats>((() => queueStats) as any),
    enabled: /*#__PURE__*/ l.boolean(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    deletedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    collection: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'nsid' }),
    ),
    description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    reportTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    subjectTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string<{
          knownValues: ['account', 'record', 'message', 'conversation']
        }>(),
      ),
    ),
    recommendedLabels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    recommendedPolicies: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
  }),
)

export { queueView }

type QueueStats = {
  $type?: 'tools.ozone.queue.defs#queueStats'

  /**
   * Percentage of reports actioned (actionedCount / inboundCount * 100), rounded to nearest integer. Absent when inboundCount is 0.
   */
  actionRate?: number

  /**
   * When these statistics were last computed
   */
  lastUpdated?: l.DatetimeString

  /**
   * Reports received in this queue in the last 24 hours.
   */
  inboundCount?: number

  /**
   * Number of unmuted reports currently not closed.
   */
  pendingCount?: number

  /**
   * Number of reports in 'closed' status
   */
  actionedCount?: number

  /**
   * Number of reports in 'escalated' status
   */
  escalatedCount?: number

  /**
   * Average time in seconds from report creation to close, for reports closed in this period.
   */
  avgHandlingTimeSec?: number

  /**
   * Percent of reports meeting their closure target.
   */
  closureTargetMetRate?: number

  /**
   * Reports whose closure meets their closure target.
   */
  closureTargetMetCount?: number

  /**
   * Reports whose closure exceeds their closure target.
   */
  closureTargetMissedCount?: number

  /**
   * Unmuted pending reports past their closure target.
   */
  closureTargetOverdueCount?: number
}

export type { QueueStats }

const queueStats = /*#__PURE__*/ l.typedObject<QueueStats>(
  $nsid,
  'queueStats',
  /*#__PURE__*/ l.object({
    actionRate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    lastUpdated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    inboundCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    avgHandlingTimeSec: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    closureTargetMetRate: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 0 }),
    ),
    closureTargetMetCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    closureTargetMissedCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
    closureTargetOverdueCount: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.integer({ minimum: 0 }),
    ),
  }),
)

export { queueStats }

type AssignmentView = {
  $type?: 'tools.ozone.queue.defs#assignmentView'
  id: number
  did: l.DidString
  endAt?: l.DatetimeString
  queue: QueueView
  startAt: l.DatetimeString

  /**
   * The moderator assigned to this queue
   */
  moderator?: TeamDefs.Member
}

export type { AssignmentView }

const assignmentView = /*#__PURE__*/ l.typedObject<AssignmentView>(
  $nsid,
  'assignmentView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    endAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    queue: /*#__PURE__*/ l.ref<QueueView>((() => queueView) as any),
    startAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
  }),
)

export { assignmentView }
